import { createSelector } from 'reselect'

import compose from 'ramda/src/compose'
import filter from 'ramda/src/filter'
import map from 'ramda/src/map'

import { parseFinancial } from '../../../lib/utils'

import { REDUCER_NAME } from './constants'
import { toSpreadsheets } from './model'

/** @type {Map<boolean, number>} */
const BOOLEAN_ORD = new Map([[false, 1], [true, -1]])

/** @type {{ [field: string]: (order: 'asc' | 'desc') => <T>(a: T, b: T) => -1 | 0 | 1 }} */
const strategy = {
  simple: order => (a, b) => {
    if (order === 'asc') return BOOLEAN_ORD.get(a < b)
    if (order === 'desc') return BOOLEAN_ORD.get(a > b)
    return 0
  },
  revenue: order => (a, b) => {
    if ([a, b].every(x => x === '-')) return 0
    if (a === '-') return 1
    if (b === '-') return -1
    return strategy.simple(order)(...[a, b].map(parseFinancial))
  },
}

/** @param {{ field: string, order: 'asc' | 'desc' }} sort */
const sortingStrategies = ({ field, order }) => {
  if (field in strategy) return strategy[field](order)
  return strategy.simple(order)
}

export const getModule = rootState => rootState.get(REDUCER_NAME)

export const getFetching = createSelector(getModule, state => state.get('fetching'))
export const getActual = createSelector(getModule, state => state.get('display_actual'))
export const getFilter = createSelector(getModule, state => state.get('filter').toJS())
export const getMoreFilter = createSelector(getModule, state => state.get('more_filter').toJS())
export const getSort = createSelector(getModule, state => state.get('sort').toJS())
export const getExportUrl = createSelector(getModule, state => state.get('url'))

export const getTable = createSelector(
  getModule,
  getMoreFilter,
  getSort,
  (state, { searchTerm }, { field, order }) => state.get('timesheets')
    .filter(timesheet => {
      const lobValue = timesheet.get('lob_name') ? timesheet.get('lob_name').toLowerCase() : '';
      const empIdValue = timesheet.get('employee_id') ? timesheet.get('employee_id').toLowerCase() : '';
      const empNameValue = timesheet.get('employee_name') ? timesheet.get('employee_name').toLowerCase() : '';
      const projectCodeValue = timesheet.get('project_code') ? timesheet.get('project_code').toLowerCase() : '';
      const textSearchTerm = searchTerm ? searchTerm.toLowerCase() : ''
      const isMatchingSearchTerm = [
        lobValue,
        empIdValue,
        empNameValue,
        projectCodeValue
      ].join(' ').includes(textSearchTerm)

      return isMatchingSearchTerm
    })
    .sortBy(timesheet => timesheet.get(field), sortingStrategies({ field, order }))
    .toJS()
)


// WEBPACK FOOTER //
// ./src/pages/report/summary-timesheet/selectors.js